module.exports = __webpack_public_path__ + "static/media/2.780ccb41.jpeg";